import classNames from 'classnames/bind';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import Amount from 'shared/components/Amount';
import type { Saldo } from 'shared/hooks/use-load-dashboard';
import type { CurrencyCode } from 'types/currency';

import styleIdentifiers from './MultiCurrencyData.module.scss';

const styles = classNames.bind(styleIdentifiers);

type Props = {
  data: Saldo;
  withTotal?: boolean;
  prefix?: string;
};

export default function MultiCurrencyData({ data, withTotal = false, prefix }: Props) {
  const { localizedTotal, ...otherCurrency } = data;
  const company = useCompanyConfiguration();

  const hasMultipleCurrency = Object.keys(otherCurrency).length > 1;
  if (!hasMultipleCurrency)
    return (
      <div className={styles('deviseLine')}>
        <Amount value={localizedTotal} prefix={prefix} />
      </div>
    );

  return (
    <div className={styles('MultiCurrencyData')}>
      {Object.keys(otherCurrency).map(currency => (
        <div key={currency} className={styles('deviseLine')}>
          <Amount
            key={currency}
            value={otherCurrency[currency as keyof typeof otherCurrency]}
            suffix={currency as CurrencyCode}
            prefix={prefix}
          />
        </div>
      ))}
      {withTotal && (hasMultipleCurrency || Object.keys(otherCurrency)[0] !== company.currency) && (
        <div className={styles('deviseLineTotal')}>
          <Amount value={localizedTotal} prefix={prefix} />
        </div>
      )}
    </div>
  );
}
